import { useNavigate } from 'react-router';
import { fetchToken, setToken } from '../components/Auth';
import { useState } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';

import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Login() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { isDirty, errors },
  } = useForm({ criteriaMode: 'all' });

  const [errorResult, setErrorResult] = useState('');

  //check to see if the fields are not empty
  const login = (data) => {
    if ((data.username === '') & (data.password === '')) {
      return;
    } else {
      // make api call to our backend. we'll leave this for later
      const headers = {
        accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      };

      const params = new URLSearchParams();
      params.append('username', data.username);
      params.append('password', data.password);

      axios
        .post('/api/v1/token', params)
        .then(function (response) {
          if (response.data.access_token) {
            setToken(response.data.access_token);
            navigate('/');
          }
        })
        // 要修正
        .catch(function (error) {
          console.error('Login error:', error);
          const res = error.response || error;
          const data = res.data || error;
          const detail = data.detail || 'エラーが発生しました';
          setErrorResult(detail);
        });
    }
  };

  return (
    <div className='login'>
      <Header></Header>
      <main>
        <Container>
          <h2>ログイン</h2>
          <div className="login-margin-top">
            {fetchToken() ? (
              <p>you are logged in</p>
            ) : (
              <>
                {errorResult && (
                  <Alert key={'danger'} variant={'danger'}>
                    Error: {errorResult}
                  </Alert>
                )}
           <div className={'form-wrapper login-form-bg'}>
                  <Form onSubmit={handleSubmit(login)}>
                    <Form.Group className="mb-3" controlId="username">
                      <Form.Label>ID</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="user id"
                        isInvalid={!!errors.username}
                        {...register('username', { required: true })}
                      />
                      {errors.username && (
                        <Form.Control.Feedback type="invalid">
                          入力が必須の項目です
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="password">
                      <Form.Label>PASSWORD</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="password"
                        isInvalid={!!errors.password}
                        {...register('password', { required: true })}
                      />
                      {errors.password && (
                        <Form.Control.Feedback type="invalid">
                          入力が必須の項目です
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                    <div className="mb-3 text-center">
                      <Button type="submit" disabled={!isDirty} variant="dark">
                        ログイン
                      </Button>
                    </div>
                  </Form>
                </div>
              </>
            )}
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
